import { render, staticRenderFns } from "./ot-invite-user-dialog.vue?vue&type=template&id=74ea2cdc&scoped=true&"
import script from "./ot-invite-user-dialog.vue?vue&type=script&lang=ts&"
export * from "./ot-invite-user-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./ot-invite-user-dialog.vue?vue&type=style&index=0&id=74ea2cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ea2cdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAlert,VForm,VMenu})
